module.exports = __webpack_public_path__ + "static/media/bg-img.0bf28038.jpg";